export enum SendStorage {
  Destination = 'SendNFTDestination',
  UserToSend = 'UserToSendNFT'
}
